<template>
  <div class="register">
    <!-- <div class="header">
      <img :src="$headLogo" alt="$headLogo" class="headerleft">
      <div class="headerright">
        <span @click="manualHelpBtn">帮助手册 </span >
        <span @click="plugBtn">插件下载</span >
      </div>
    </div> -->
    <div class="content">
      <div class="main">
        <div class="box" >
          <div>
            <div class="stepsStyle">
              <steps ref="stepsChild" :key="stepsIndex" :width='width'></steps>
            </div>
            <div class="tjform">
              <el-form v-show="stepsIndex == 0" ref="loginForm1" :model="loginForm1" label-position="left" label-width="0px" >
                <el-form-item :rules="[ { required: true, validator: validatephone1, trigger: 'change' } ]" prop="phone" style="margin-bottom: 0px" >
                  <el-input v-model.trim="loginForm1.phone" type="text" auto-complete="off" placeholder="请输入手机号" @input="ddd" @keydown.native="keydown($event)" ></el-input>
                </el-form-item>
                <el-form-item :rules="[ { required: true, message: '请输入短信验证码', trigger: 'change' } ]" prop="verifyCode" style="margin-top: 59px;margin-bottom: 0px" class="Sphone_code" >
                  <el-input v-model.trim="loginForm1.verifyCode" type="text" auto-complete="off" placeholder="请输入短信验证码" @keydown.native="keydown($event)" >
                    <p v-if="!time" slot="suffix" class="goMunberBoxStyle" @click="getverificationcode" >
                      <el-popover :disabled="disabled" v-model="visible" placement="top-end" popper-class="popperverify" width="400" trigger="manual" >
                        <div style="margin:10px 10px 15px 10px;">
                          <div style="margin-bottom:8px">
                            <span class="titleLeft" >完成拼图验证</span >
                            <span class="titleRight" @click="shuaxin" >
                              <i class="el-icon-refresh">换一张</i>
                            </span>
                            <span style="color:#BDC8D9;cursor: pointer;">
                              <i class="el-icon-close" @click="close"></i>
                            </span>
                          </div>
                          <slideverify ref="verify" @success="success" @fail="fail" ></slideverify>
                        </div>
                        <p slot="reference" @click="onvisible">获取验证码</p>
                      </el-popover>
                    </p>
                    <p v-if="time" slot="suffix" class="timeStyle" > {{ time }}秒后可重新获取 </p>
                  </el-input>
                </el-form-item>
                <el-form-item :rules="[ { required: true, trigger: 'change', validator: validatechecked1 } ]" prop="checked" class="checked" >
                  <el-checkbox v-model="loginForm1.checked" class="rememberme" >我已阅读并同意{{$appTitle}}</el-checkbox ><span style="color:#68B2FF;cursor:pointer;" @click="openUserAgr">《用户协议》</span>
                </el-form-item>
                <el-form-item style="width: 100%;margin-bottom: 0px">
                  <el-button type="primary" class="nextStyle" @click="handleRegister('loginForm1')" >下一步</el-button >
                </el-form-item>
                <p style="float: right;margin-top: 18px" @click="gplogin" class="gploginStyle">
                  <span style="color:#333;" >已有账号?</span >
                  <span style="color:#1E6EF5;" >立即登录></span >
                </p>
              </el-form>
              <el-form v-show="stepsIndex == 1" ref="loginForm2" :model="loginForm2" :rules="rules2" label-position="left" label-width="0px" >
                <el-form-item prop="password1" style="margin-bottom: 0px">
                  <el-input style="position:fixed;top:-9999px;" type="text" @keydown.native="keydown($event)" ></el-input>
                  <el-input v-model.trim="loginForm2.password1" :type="passwordType1" auto-complete="new-password" placeholder="请设置6-20位登录密码,至少包含大小写字母、数字、符号两种类型" @keydown.native="keydown($event)" @input="inputMethod" >
                    <p v-if="passwordType1 == 'text' && loginForm2.password1" slot="suffix" class="bukejin" @click="showPwd1" ></p>
                    <p v-if="passwordType1 == 'password' && loginForm2.password1" slot="suffix" class="nobukejin" @click="showPwd1" ></p>
                  </el-input>
                  <p v-if="noteshow" style="position: absolute;top:54px;font-size:12px" >
                    <span style="color:#e6a23c;">{{ str2 }}</span>
                  </p>
                </el-form-item>
                <el-form-item prop="password2" style="margin-top: 59px;margin-bottom: 0px" >
                  <el-input v-model.trim="loginForm2.password2" :type="passwordType2" auto-complete="new-password" placeholder="请再次输入密码" @input="changeInputValue2()" @keydown.native="keydown($event)" >
                    <p v-if="passwordType2 == 'text' && loginForm2.password2" slot="suffix" class="bukejin" @click="showPwd2" ></p>
                    <p v-if="passwordType2 == 'password' && loginForm2.password2" slot="suffix" class="nobukejin" @click="showPwd2" ></p>
                  </el-input>
                </el-form-item>
                <el-form-item style="width: 100%;margin:59px 0px 0px 0px" >
                  <el-button :logining="logining" type="primary" class="handleRegisterStyle" @click="handleRegister2('loginForm2')" >立即注册</el-button >
                </el-form-item>
                <p style="float: right;margin-top: 18px" @click="gplogin">
                  <span style="font-size:14px;color:#333;cursor: pointer;" >已有账号?</span >
                  <span style="font-size:14px;color:#1E6EF5;cursor: pointer;" >立即登录></span >
                </p>
              </el-form>
              <el-form v-show="stepsIndex == 2" label-position="left" label-width="0px" >
                <div style="text-align: center;margin-top:18px">
                  <img :src="zhuce" alt="" />
                </div>
                <p style="color:#323232;font-size:26px;text-align: center;"> 恭喜您已成功注册标准版账号!!! </p>
                <p style="color:#5584FF;font-size:14px;text-align: center;margin-top:17px" >
                  创建企业或加入已有企业后，即可体验标准版功能~
                </p>
                <div style="margin:0 auto;text-align: center;margin-top:22px;">
                  <el-button type="primary" size="mini" plain @click="experienceEnterprise" >体验试用企业</el-button >
                  <el-button type="primary" size="mini" @click="goconsentagree" >创建新企业</el-button >
                </div>
              </el-form>
            </div>
            <div v-show="stepsIndex == 2" style="margin: 0 auto;margin-top: 63px;" >
              <ul>
                <li v-for="(item, index) in nojoinEnterpriseList" :key="index" style="color:#7A85A2;text-align: center;font-size: 14px;margin-top:5px;cursor: pointer;margin-top: 10px;" >
                  <span>企业</span>【{{ item.enterpriseName }}】<span >邀请您加入企业，</span >
                  <span class="lijilook" @click="golook(item)">立即查看></span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" :before-close="handleClose" title="欢迎加入试用企业!" width="427px" custom-class="sureExperience-dialog" >
      <p style="margin-bottom:28px;color:#5584FF">
        试用企业每三天自动清理一次试用数据，请及时将有用的信息保存至本地
      </p>
      <p style="margin-bottom:12px;">姓名</p>
      <el-input v-model="nameinput" :disabled="namedisable" placeholder="请输入您的姓名(必填)" size="small" ></el-input>
      <p style="margin-top:33px;margin-bottom:12px">企业名称</p>
      <el-input v-model="prjinput" placeholder="请输入您的企业名称" size="small" ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="loadinging" @click="dialogVisible = false" >取 消</el-button >
        <el-button :loading="loadinging" type="primary" @click="sureExperience" >确 定</el-button >       
      </span>
    </el-dialog>
    <!-- 插件端下载 -->
    <el-dialog v-dialogDrag :visible.sync="downloadDialog" :close-on-click-modal="false" :close-on-press-escape="false" title="客户端下载" width="500px">
      <div class="downunit">
        <img :src="$appLogo" alt="标准版"  class="downunit-bottom" />
        <span class="downunit-bottom downunit-font">{{ $appTitle }}</span>
        <el-button type="primary" size="small" class="downunit-bottom" @click="downPlugBtn">客户端下载</el-button>
        <span class="downunit-bottom">更新时间：{{ plugForm.createTime }}</span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import slideverify from "@/CommonDP/components/monoplastyslideverify/index";
import steps from "@/CommonDP/components/steps";
import registerService from "@/xgzdService/login-service";
import enterpriseService from "@/CommonDP/service/enterprise-service";
import loginService from "@/CommonDP/service/login-service";
export default {
  name: "Register",
  components: {
    steps,
    slideverify
  },
  data() {
    var validatePass = (rule, value, callback) => {
      var idCardx = /[\u4e00-\u9fa5]/;
      var mediumRegex = new RegExp(
        "^(((?=.*[A-Z])(?=.*[a-z]))|((?=.*[A-Z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[a-z])(?=.*\\W))|((?=.*[0-9])(?=.*\\W))|((?=.*[A-Z])(?=.*\\W))).*$",
        "g"
      );
      if (value === "") {
        this.noteshow = false;
        callback(new Error("请输入密码"));
      } else if (idCardx.test(value)) {
        this.noteshow = false;
        callback(new Error("密码不允许中文"));
      } else if (value.length < 6 || value.length > 20) {
        this.noteshow = false;
        callback(new Error("密码长度为6~20个字符"));
      } else if (!mediumRegex.test(value)) {
        this.noteshow = false;
        callback(
          new Error("请至少使用大小写字母、数字、符号两种类型组合的密码")
        );
      } else {
        if (this.loginForm2.password2 !== "") {
          this.$refs.loginForm2.validateField("password2");
        }
        this.noteshow = true;
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.loginForm2.password1) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      stepsIndex: 0,
      loginForm1: { phone: "", verifyCode: "", checked: "" },
      loginForm2: { password1: "", password2: "" },
      time: "",
      disabled: true,
      visible: false,
      repeat1: "",
      repeat2: "",
      repeat3: "",
      dd: false,
      rules2: {
        password1: [
          { required: true, validator: validatePass, trigger: "change" }
        ],
        password2: [
          { required: true, validator: validatePass2, trigger: "change" }
        ]
      },
      passwordType1: "text",
      passwordType2: "text",
      zhuce: require('@/CommonDP/assets/register/支付成功 (1).png'),
      logining: false,
      checked: false,
      dialogVisible: false,
      nameinput: "",
      namedisable: false,
      prjinput: "",
      erpriseList: [],
      loadinging: false,
      nojoinEnterpriseList: [],
      str2: "",
      noteshow: false,
      width:'270',
      downloadDialog: false,
      plugForm: {
        createTime: "",
        filePath: ""
      },
    };
  },

  created() {
    this.stepsIndex = JSON.parse(sessionStorage.getItem("stepsIndex"));
    if (this.stepsIndex === 2) {
      this.quergetInviteJoinEnterpriseList();
    }
  },
  methods: {
    openUserAgr(){},
    //帮助手册提示
    manualHelpBtn() {
      this.$message.warning("请登录后再进行帮助手册的查看与下载操作")
    },
    async plugBtn() {
      this.downloadDialog = true;
      const res = await enterpriseService.getPlugList();
      if(res.data&&res.data.length>0){
        const a = res.data[0].createTime.split(" ")[0];
        this.plugForm.createTime = a.replace(/-/g, "/");
        this.plugForm.filePath = res.data[0].filePath;
      }
    },
    downPlugBtn() {
      if (this.plugForm.filePath) {
        const fileUrl = enterpriseService.downloadUrlone(this.plugForm.filePath);
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.style.height = 0;
        iframe.src = fileUrl;
        document.body.appendChild(iframe);
        setTimeout(() => { iframe.remove();}, 5 * 60 * 1000);
      } else {
        this.$message.warning("暂无文件");
      }
    },
    inputMethod(value) {
      if (!this.loginForm2.password1) {
        this.passwordType1 = "text";
      } else {
        this.passwordType1 = "password";
      }
      var strongRegex = new RegExp( "^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*\\W).*$", "g" );
      var mediumRegex = new RegExp( "^(((?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[a-z])(?=.*\\W))|((?=.*[A-Z])(?=.*[0-9])(?=.*\\W))|((?=.*[a-z])(?=.*[0-9])(?=.*\\W))).*$", "g" );
      var enoughRegex = new RegExp( "^(((?=.*[A-Z])|(?=.*[a-z]))|((?=.*[A-Z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[a-z])(?=.*\\W))|((?=.*[0-9])(?=.*\\W))|((?=.*[A-Z])(?=.*\\W))).*$", "g" );
      if (strongRegex.test(value)) {
        this.str2 = "当前密码强度：强";
      } else if (mediumRegex.test(value)) {
        this.str2 = "当前密码强度：中等";
      } else if (enoughRegex.test(value)) {
        this.str2 = "当前密码强度：弱";
      }
    },
    showPwd1() {
      if (this.passwordType1 === "password") {
        this.passwordType1 = "text";
      } else {
        this.passwordType1 = "password";
      }
    },
    showPwd2() {
      if (this.passwordType2 === "password") {
        this.passwordType2 = "text";
      } else {
        this.passwordType2 = "password";
      }
    },
    keydown(event) {
      if (event.keyCode === 32) {
        event.returnValue = false;
      }
    },
    changeInputValue2() {
      if (!this.loginForm2.password2) {
        this.passwordType2 = "text";
      } else {
        this.passwordType2 = "password";
      }
    },
    ddd() {
      this.dd = false;
    },
    validatechecked1(rule, value, callback) {
      if (value === "") {
        callback(new Error("请勾选用户协议"));
      } else if (value === false) {
        callback(new Error("请勾选用户协议"));
      } else {
        callback();
      }
    },
    validatephone1(rule, value, callback) {
      var idCardx = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
      this.disabled = true;
      this.repeat1 = callback;
      this.repeat2 = value;
      this.repeat3 = rule;
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (this.loginForm1.phone.length > 11) {
        callback(new Error("手机号码不得超过11位"));
      } else if (!idCardx.test(value)) {
        callback(new Error("请输入正确的手机号码"));
      } else if (this.dd) {
        this.visible = false;
        callback(new Error("该手机号已注册"));
      } else {
        this.disabled = false;
        callback();
      }
    },
    handleRegister(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          var params1 = {
            phone: this.loginForm1.phone,
            verifyCode: this.loginForm1.verifyCode,
            smsTemplateId: "1717692"
          };
          registerService.smscheckVerifyCode(params1).then(res => {
            if (res.result === "0" && res.data) {
              var params = {
                phone: this.loginForm1.phone,
                verifyCode: this.loginForm1.verifyCode,
                uuid: res.data
              };
              this.stepsIndex = 1;
              sessionStorage.setItem("stepsIndex", 1);
              sessionStorage.setItem("loginFormz", JSON.stringify(params));
            }
          }).catch(() => {});
        } else {
          return false;
        }
      });
    },
    handleRegister2(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          var params = {
            phone: JSON.parse(sessionStorage.getItem("loginFormz")).phone,
            verifyCode: JSON.parse(sessionStorage.getItem("loginFormz"))
              .verifyCode,
            uuid: JSON.parse(sessionStorage.getItem("loginFormz")).uuid,
            password: this.loginForm2.password1,
          };
          this.logining = true;
          registerService.userregister(params).then(res => {
            if (res.result === "0") {
              this.logining = false;
              this.$store.dispatch('setUserInfo',res.data)
              // 注册成功以后 如果有参数就直接跳到加入企业页面 没有参数就跳到第三步
              if (this.$route.query.code) {
                var code = this.$route.query.code;
                this.$router.replace({
                  path: "/joinEnterprise",
                  query: { code: code }
                });
              } else {
                this.quergetInviteJoinEnterpriseList();
                this.stepsIndex = 2;
                sessionStorage.setItem("stepsIndex", 2);
              }
            }
          }).catch(() => {
            this.logining = false;
          });
        } else {
          return false;
        }
      });
    },
    quergetInviteJoinEnterpriseList() {
      registerService.getInviteJoinEnterpriseList().then(res => {
        if (res.result === "0") {
          this.nojoinEnterpriseList = res.data;
        }
      }).catch(() => {});
    },
    onvisible() {
      this.$refs.verify.refresh();
      if (this.disabled) {
        this.visible = false;
      } else {
        this.visible = true;
      }
    },
    shuaxin() {
      this.$refs.verify.refresh();
    },
    getverificationcode() {
      if (!this.loginForm1.phone) {
        this.$refs.loginForm1.validateField("phone");
      }
    },
    gplogin() {
      if (this.$route.query.code) {
        var code = this.$route.query.code;
        this.$router.replace({ path: "/login", query: { code: code }});
      } else {
        this.$router.push({name:'login'});
      }
    },
    close() {
      this.visible = false;
    },
    success() {
      var encoded = encodeURI(this.repeat2);
      var params = { phone: encoded };
      registerService.userexists(params).then(res => {
        if (res.data !== 0) {
          this.dd = true;
          this.$refs.loginForm1.validateField("phone");
        } else {
          this.dd = false;
          this.$refs.loginForm1.validateField("phone");
          // 开始发起验证码
          var params = {
            phone: this.loginForm1.phone,
            smsTemplateId: "1717692"
          };
          registerService.smssendVerifyCode(params).then(res => {
            if (res.result === "0") {
              this.time = 60;
              this.visible = false;
              this.$message.success("验证通过!");
              this.flushTime();
            }
          }).catch(() => {});
        }
      });
    },
    flushTime() {
      const that = this;
      const intval = setInterval(function() {
        that.time--;
        if (that.time < 1) {
          that.time = 0;
          clearInterval(intval);
        }
      }, 1000);
    },
    fail() {},
    goconsentagree() {
      var params = { enterpriseName: "", creditCode: "", userName: "", idCard: "", verifyCode: "", fileList1: [], fileList2: [] };
      sessionStorage.setItem("setenterpriseForm", JSON.stringify(params));
      sessionStorage.setItem("setchecked", JSON.stringify(this.checked));
      this.$router.replace({
        path: "/consentagree"
      });
    },
    experienceEnterprise() {
      loginService.getUserInfo().then(res => {
        if (res.result === "0") {
          if (res.data.name) {
            this.namedisable = true;
            this.nameinput = res.data.name;
            this.experienceEnterprise2();
          } else {
            this.namedisable = false;
            this.nameinput = "";
            this.experienceEnterprise2();
          }
        }
      })
    },
    experienceEnterprise2() {
      // 查询他有没有试用企业
      enterpriseService.usergetEnterpriseList().then(res => {
        if (res.result === "0") {
          this.erpriseList = res.data;
          const experiencelist = this.erpriseList.filter(
            item => item.isTrial === '1'
          );
          if (experiencelist.length === 0) {
            if (!this.namedisable) {
              this.nameinput = "";
            }
            this.prjinput = "";
            this.dialogVisible = true;
          } else {
            this.$store.dispatch("setIsTrial", experiencelist[0].isTrial);
            this.$store.dispatch("setEnterpriseId", experiencelist[0].enterpriseId);
            this.$router.push({name:"mainMg"});
          }
        }
      })
    },
    handleClose() {
      this.dialogVisible = false;
    },
    sureExperience() {
      if (this.nameinput) {
        this.loadinging = true;
        var data = { name: this.nameinput, enterpriseName: this.prjinput };
        registerService.jointrial(data).then(res => {
          if (res.result === "0") {
            this.loadinging = false;
            this.dialogVisible = false;
            this.$store.dispatch("setEnterpriseId", res.data.enterpriseId);
            this.$store.dispatch("setIsTrial", res.data.isTrial);
            this.$router.push({name:"mainMg"});
          }
        }).catch(() => {
          this.loadinging = false;
        });
      } else {
        this.$message.warning("请输入您的姓名");
      }
    },
    golook(row) {
      var code = row.inviteCode;
      const { href } = this.$router.resolve({
        path: "/joinEnterprise",
        query: {
          code: code
        }
      });
      window.open(href, "_blank");
    }
  }
};
</script>
<style lang="scss" scoped>
.register {
  min-width: 1000px;
  width: 100%;
  min-height: 800px;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  .header {
    width: 100%;
    height: 68px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: rgba(0, 0, 0, 0.77);
    .headerleft {
      height: 100%;
    }
    .headerright {
      float: right;
      span {
        margin-right: 53px;
        font-size: 14px;
        color: #fff;
        font-family: PingFang SC;
        font-style: normal;
        font-weight: 400;
        cursor: pointer;
      }
    }
  }
  .content {
    // position: absolute !important;
    // position: relative;
    // top: 68px !important;
    // bottom: 0px;
    width: 100%;
    overflow: hidden;
    height: auto !important;
    left: 0px;
  }
  .main {
    height: 100%;
    min-height: 1000px;
    overflow-y: auto;
    background: url("../../CommonDP/assets/enterprise/qiye.png") no-repeat;
    background-attachment: fixed;
    background-size: cover;
    .box {
      position: absolute;
      top: 50%;
      left: 50%;
      width:836px;
      min-height:533px;
      background:#ffffffbf;
      border-radius: 8px;
      padding-bottom:26px;
      -webkit-transform: translate(-50%, -50%);
      -moz-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      -o-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      .stepsStyle{
        margin:0 auto;
        padding-top:58px;
        height:85px;
      }
      .tjform {
        width: 490px;
        margin: 0 auto;
        margin-top: 52px;
        .el-input {
          width: 490px;
        }
        /deep/ .el-form-item {
          margin-bottom: 0px;
          .el-input__inner {
            background: #e8f0fe;
            border-color: #fff;
            border-radius: 2px;
            color: #6681a0;
            height: 46px;
          }
          .el-input__inner:focus {
            border-color: #1e6ef5;
          }
          .el-button--primary {
            background: #72a6fe !important;
          }
          .el-button--primary:hover {
            background: #5584ff !important;
          }
          .el-form-item__content {
            line-height: 0px;
          }
        }
        .Sphone_code {
          /deep/ .el-input__suffix {
            right: 15px;
          }
          .goMunberBoxStyle{
            color:#1E6EF5;
            height:45px;
            line-height:45px;
            cursor: pointer;
          }
          .timeStyle{
            color:#1E6EF5;
            height:45px;
            line-height:45px;
          }
        }
        .checked {
          width:490px;
          margin-bottom: 0px;
          /deep/ .el-form-item__content {
            height: 20px;
            line-height: 0px;
            margin: 25px 0px 21px 0pc;
            .el-form-item__error {
              top: 17px;
            }
          }
        }
        .nextStyle{
          width: 490px!important;
          height: 46px!important;
          border-radius: 2px!important;
          border:none!important;
        }
        .gploginStyle{
          span{
            font-size:14px;
            cursor: pointer;
          }
        }
        .bukejin {
          width: 20px;
          height: 16px;
          background: url("../../CommonDP/assets/可见.png") no-repeat;
          background-size: 100% 100%;
          background-position: center center;
          margin-top: 15px;
          margin-right: 15px;
        }
        .nobukejin {
          width: 20px;
          height: 16px;
          background: url("../../CommonDP/assets/不可见.png") no-repeat;
          background-size: 100% 100%;
          background-position: center center;
          margin-top: 15px;
          margin-right: 15px;
        }
        .handleRegisterStyle{
          width: 490px!important;
          height: 46px!important;
          border-radius: 2px!important;
          border:none!important;
        }
      }
      .lijilook {
        color: #5584ff;
      }
    }
  }
  .downunit {
    display: flex;
    flex-direction: column;
    align-items: center;
    .downunit-bottom {
      margin-bottom: 10px;
      img{
        height:50px;width:50px
      }
    }
    .downunit-font{
      font-weight:600;font-size:20px;letter-spacing:2px
    }
  }
  /deep/ .sureExperience-dialog {
    border-radius: 5px;
    .el-dialog__body {
      padding: 20px;
      padding-top: 15px;
      padding-bottom: 56px;
      border-top: 1px solid #2e5bff1a;
      border-bottom: 1px solid #2e5bff1a;
    }
    .el-button--primary {
      background: #4777e7;
      border-color: #4777e7;
    }
    .el-button--primary:hover {
      background: #7397ec;
      border-color: #7397ec;
    }
  }
}
</style>
<style>
.popperverify {
  width: 490px !important;
  left: 715px !important;
  top: 205px !important;
  padding: 0px !important;
}
.popperverify .titleLeft{
  color:#333;
  font-size:12px;
  margin-right:270px;
  cursor: default;
}
.popperverify .titleRight{
  color:#5584FF;
  margin-right:43px;
  cursor: pointer;
}
.popperverify .popper__arrow {
  left: 434.5px !important;
}
</style>
